import React from 'react';
import { Typography } from '@mui/material';

import { PlayerDetailsProps, Row } from '@/types/general';
import { paths } from '@/paths';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function PlayerActionsTable({ playerData }: { playerData: PlayerDetailsProps }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        component: (
          <Typography variant="body2" color="var(--mui-palette-text-secondary)" sx={{ flexShrink: 0 }}>
            Total Tickets: <span style={{ color: 'var(--mui-palette-text-primary)' }}>100</span>
          </Typography>
        ),
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Bets',
      },
      value: {
        link: {
          href: paths.dashboard.bets.playerBets(playerData.playerCode),
        },
      },
    },
    {
      label: {
        text: 'All Transactions',
      },
      value: {
        link: {
          href: paths.dashboard.transactions.playerTransactions(playerData.playerCode),
        },
      },
    },
    {
      label: {
        text: 'Player Stats Reports',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Deposit Orders',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Withdraw Orders',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Affiliate Reports',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Bonus Reports',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Sports Free Bets',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Casino Free Bets',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Logs',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'JSON',
      },
      value: {
        link: {
          href: '',
        },
      },
    },

    {
      label: {
        text: 'Affiliate Report',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
    {
      label: {
        text: 'Username',
      },
      value: {
        link: {
          href: '',
        },
      },
    },
  ];

  return <HorizontalTable tableData={tableData} />;
}
